import { create_user_path } from '../../routes';
import request from './request';

export interface userCreateParams {
  email: string;
  redirect_to_on_success?: string;
}

export async function createUser(params) {
  const resp = await request('post', create_user_path(params));
  return resp;
}
